module.exports = __webpack_public_path__ + "static/media/checkedCheckbox.e400233d.svg";